import React, {useContext, useEffect, useState} from 'react';
import AbroadItem from "../components/Abroad-item/AbroadItem";
import {axios} from "../axios";
import {LangContext} from "../App";
import Seo from "../components/Seo/Seo";



const Abroad = () => {
    const [type, setType] = useState('')
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/abroad?type=${type}`)
            .then(res => setData(res.data.tours))
    },[lang,type])
    return (
        <div className='abroad'>
            <Seo pageKey="lesserArmenia" />
            <div className="center-wrapper flex-column">
                <div className="d-flex">
                    <button
                        onClick={()=> setType('')}
                        className={`btn btn-custom ${type === '' && 'active'}`}
                    >All</button>
                    <button
                        onClick={()=> setType('private')}
                        className={`btn btn-custom ${type === 'private' && 'active'}`}
                    >Private tours</button>
                    <button
                        onClick={()=> setType('group')}
                        className={`btn btn-custom ${type === 'group' && 'active'}`}
                    >Group tours</button>
                </div>
                <div className="abroad-list">
                    {data?.map(e => <AbroadItem path='abroad' key={e.id} tour={e}/>)}
                </div>
            </div>
        </div>
    );
};

export default Abroad;